import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, query, where, doc, addDoc } from 'firebase/firestore';
import { getStorage, ref, getDownloadURL } from "firebase/storage";

// Connect to current firebase project
const firebaseApp = initializeApp({
  apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
  authDomain: "ambient-systems.firebaseapp.com",
  databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ambient-systems",
  storageBucket: "ambient-systems.appspot.com",
  messagingSenderId: "1001740093061",
  appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
});
const firestore = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: 'calc(-50% + 16px)',
      right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#784af4',
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
      borderTopWidth: 3,
      borderRadius: 1,
    },
  }));
  
  const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
      color: '#784af4',
    }),
    '& .QontoStepIcon-completedIcon': {
      color: '#784af4',
      zIndex: 1,
      fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
  }));
  
  function QontoStepIcon(props) {
    const { active, completed, className } = props;
  
    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle" />
        )}
      </QontoStepIconRoot>
    );
  }
  
  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
  };

export default function DataProcessingPage() {
  const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    useEffect(() => {
      const connectorQuery = query(
        collection(firestore, 'connectors'),
        where('user_email', '==', user_email)
      );
        const unsubscribe = onSnapshot(connectorQuery, snapshot => {
          setFeed(snapshot.docs.map(doc => ({id: doc.id, data: doc.data() })))
        })

        return () => {
          unsubscribe()
        }
      }, [])
    const [feed, setFeed] = useState([]);
    const [choice, setChoice] = useState([]);

    const [openD, setOpenD] = useState(false);

    const [type, setType] = useState([]);

    var outcome = ""
    const [result, setResult] = useState("");

    const [status, setStatus] = useState(0);
    const [steps, setSteps] = useState([]);
    const steps1 = ['Checking file format', 'test for 2', 'test for 3', 'test for 4', 'test for 5'];
    const steps2 = ['Checking file format', 'test for B', 'test for C', 'test for D', 'test for E'];

    function formatDate() {
      var d = new Date(),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
  
      return [year, month, day].join('-');
    }  

    const onFileChange = (e) => {
        const file = e.target.files[0]
        handleFile(file)
    }

    function handleFile(file) {
        const reader = new FileReader()
  
        reader.onload = function (e) {
          const text = e.target.result;
          var Data = csvToArray(text);
          Data.pop()
          if (type == "") {
            alert("Please follow the step 1 and choose a type of your file!")
          } else {
            if (type == "BIM") {
              setSteps(steps1)
              setOpenD(true)
              workflow1(Data)
            } else {
              setSteps(steps2)
              setOpenD(true)
              workflow2(Data)
            }
          }
        };
  
        reader.readAsText(file)
    }

    function csvToArray(str, delimiter = ",") {
      const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
      const rows = str.slice(str.indexOf("\n") + 1).split("\n");
      const arr = rows.map(function (row) {
        const values = row.split(delimiter);
        const el = headers.reduce(function (object, header, index) {
          object[header] = values[index];
          return object;
        }, {});
        return el;
      });

      return arr
    }

    function validation2(data) {
      outcome = ""
      // Check headers
      const keys = Object.keys(data[0])
      if (!keys.includes("Date/Time")) {
        outcome = "Missing attribute Date/Time"
        return 
      }

      var time = []
      // Check if data is timestamp or float number
      data.forEach(elem => {
        if (time.includes(elem["Date/Time"])) {
          outcome = "Date is not unique: " + elem["Date/Time"]
          return 
        } else {
          time.push(elem["Date/Time"])
        }

        if (new Date(elem["Date/Time"]) == 'Invalid Date') {
          outcome = "Data in attribute Date/Time is not Timestamp type"
          return 
        }

        var tmp = elem
        delete tmp["Date/Time"]
        Object.values(tmp).forEach((num) => {
          if (isNaN(parseFloat(num))) {
            outcome = "Some data is not in right format: " + num
            return
          }
        })
      })
    }

    function validation1(data) {
      outcome = ""
      // Check headers
      const keys = Object.keys(data[0])
      const headers = ['Name', 'CreatedBy', 'CreatedOn', 'TypeName', 'Space', 'Description', 'ExtIdentifier']
      var missing = []
      headers.forEach(element => {
        if (!keys.includes(element)) {
          missing.push(element)
        }
      });
      if (missing.length > 0) {
        outcome = "Missing attribute " + missing
        return 
      }

      // Check if data is unique, not null or timestamp
      var names = []
      var identifier = []

      data.forEach(elem => {
        if (elem.Name == '' || elem.Name == undefined) {
          outcome = "Attribute Name has empty value"
          return 
        }

        if (elem.ExtIdentifier == '' || elem.ExtIdentifier == undefined) {
          outcome = "Attribute ExtIdentifier has empty value"
          return 
        }

        if (elem.CreatedOn == '' || elem.CreatedOn == undefined) {
          outcome = "Attribute CreatedOn has empty value"
          return 
        }

        if (names.includes(elem.Name)) {
          outcome = "Name is not unique: " + elem.Name
          return 
        } else {
          names.push(elem.Name)
        }

        if (identifier.includes(elem.ExtIdentifier)) {
          outcome = "Name is not unique: " + elem.ExtIdentifier
          return 
        } else {
          identifier.push(elem.ExtIdentifier)
        }

        if (new Date(elem.CreatedOn) == 'Invalid Date') {
          outcome = "Data in attribute CreatedOn is not Timestamp type"
          return 
        }
      });
    }

    const handleClose = () => {
        setOpenD(false)
    }

    const workflow1 = (Data) => {
      setTimeout(function(){
        validation1(Data);
        if (outcome != "") {
          setOpenD(false)
          setResult(outcome)
          setStatus(0)

          const email = user_email
          const content = "Data processing result : " + outcome
          const date = formatDate()
          const time = new Date()
          addDoc(collection(firestore, 'alerts'), {email, content, date, time})
        }
      }, 1000);
      setTimeout(function(){
        setStatus(2);
      }, 3000);
      setTimeout(function(){
        setStatus(4);
      }, 4000);
      setTimeout(function(){
        if (outcome == "") {
          setResult("No problem")
          if(flag) {
            const CollectionRef = collection(firestore, 'models')
            const name = "Recommender System"
            addDoc(CollectionRef, {name, user_email})
          }
        }
        setOpenD(false)
        setStatus(0)
      }, 6000);
    }

    const workflow2 = (Data) => {
      setTimeout(function(){
        validation2(Data);
        if (outcome != "") {
          setOpenD(false)
          setResult(outcome)
          setStatus(0)

          const email = user_email
          const content = "Data processing result : " + outcome
          const date = formatDate()
          const time = new Date()
          addDoc(collection(firestore, 'alerts'), {email, content, date, time})
        }
      }, 2000);
      setTimeout(function(){
        setStatus(2);
      }, 3000);
      setTimeout(function(){
        setStatus(3);
      }, 4000);
      setTimeout(function(){
        setStatus(4);
      }, 5000);
      setTimeout(function(){
        if (outcome == "") {
          setResult("No problem")
          if(flag) {
            const CollectionRef = collection(firestore, 'models')
            const name = "Recommender System"
            addDoc(CollectionRef, {name, user_email})
          }
        }
        setOpenD(false)
        setStatus(0)
      }, 7000);
    }

    function handleFeed() {
      if (choice == "") {
        alert("Please select a valid feed!")
      }

      var nameToFile = new Array()
      feed.forEach((element) => {
        nameToFile[element.data.name] = element.data.file
      })

      const filename = nameToFile[choice]
      getDownloadURL(ref(storage, user_email + '/' + filename))
      .then((url) => {
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = (event) => {
          const blob = xhr.response;
          handleFile(blob)
        };
        xhr.open('GET', url);
        xhr.send();
      })
      .catch((error) => {
        console.log(error.message)
        alert(error.message)
      });
    }

    const [flag, setFlag] = React.useState();
    React.useEffect(() => {
      const modelQuery = query(
        collection(firestore, 'models'),
        where('user_email', '==', user_email),
        where('name', '==', 'Recommender System'),
      );
      onSnapshot(modelQuery, snapshot => {
          const t = (snapshot.docs.map(doc => ({ id: doc.id, data: doc.data() })))
          if (!t[0]) {
              setFlag(true)
          } else {
              setFlag(false)
          }
      })
    }, []);

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {/* Sub-Sidebar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                    {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>
                
                <Divider />

                <List component="nav">
                    <ListItemButton href="/Dashboard/Engineering" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Feeds" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Engineering/Processing" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Processing" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Engineering/Augmentation" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Augmentation" />
                    </ListItemButton>
                </List>
            </Drawer>

            {/* Main space of page*/}
            <Box>
                {/* Title */}
                <Box sx={{ width: '100%' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Data Engineering / Data Processing
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Data Processing
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="h6" color="#008000" sx={{ flexGrow: 1, mt: 3, ml: 8 }}>Step 1</Typography>

                    <Box sx={{ display: "flex" }}>
                        <Typography variant="subtitle1" sx={{ ml: 8 }}>Choose type:</Typography>
                        <RadioGroup row sx={{ mt: -1, ml: 4 }} onChange={(e) => setType(e.target.value)}>
                            <FormControlLabel value="BIM" control={<Radio />} label="BIM" />
                            <FormControlLabel value="Energy" control={<Radio />} label="Energy Utility" />
                        </RadioGroup>
                    </Box>

                    <Typography variant="h6" color="#008000" sx={{ flexGrow: 1, mt: 3, ml: 8 }}>Step 2</Typography>
                    <Box sx={{ display: 'flex' }}>
                      <Typography variant="h7" sx={{ ml: 8, mt: 1.5 }}>Choose local file: </Typography>
                      <Button variant="contained" color='primary' component="label" sx={{ ml: 3, mt: 1 }}>
                          upload file
                          <input
                              type="file"
                              accept=".csv"
                              hidden
                              onChange={onFileChange}
                          />
                      </Button>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                      <Typography variant="h7" sx={{ ml: 8, mt: 3 }}>Or choose file uploaded: </Typography>
                      <FormControl sx={{ ml: 2, mt: 2, minWidth: 200 }} variant= "standard">
                        <Select native label="Select File" disableUnderline onChange={(e) => setChoice(e.target.value)}
                          theme={theme}
                          sx={{
                              borderRadius: 25,
                              backgroundColor: theme.palette.background.default,
                              padding: "6px 15px",
                          }}
                        >
                          <option value=""></option>
                          {feed?.map((row) => (
                            <option value={row.data.name}>{row.data.name}</option>
                          ))}
                        </Select>
                      </FormControl>
                      <Box>
                        <Button variant="contained" color='primary' component="label" sx={{ ml: 3, mt: 2.5 }} onClick={handleFeed}>confirm</Button>
                      </Box>
                    </Box>

                    <Typography variant="h6" color="#008000" sx={{ flexGrow: 1, mt: 3, ml: 8 }}>Step 3</Typography>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, ml: 8 }}>Automatically Checking the format of file uploaded</Typography>

                    <Typography variant="h6" color="#008000" sx={{ flexGrow: 1, mt: 3, ml: 8 }}>Step 4</Typography>
                    <Typography variant="subtitle1" sx={{ flexGrow: 1, ml: 8 }}>Outcome: </Typography>
                    {result &&
                      <Box sx={{ ml: 8, mt: 1 }}>
                        <Typography variant="subtitle1" color="#FFBF00" >{result}</Typography>
                      </Box>
                    }
                </Box>

                <Dialog open={openD} onClose={handleClose}>
                    <DialogTitle>Format Check</DialogTitle>
                    <DialogContent>
                        <Stack sx={{ width: '100%', mt: 4, mb: 2 }} spacing={4}>
                            <Stepper alternativeLabel activeStep={status} connector={<QontoConnector />}>
                                {steps.map((label) => (
                                <Step key={label}>
                                    <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
                                </Step>
                                ))}
                            </Stepper>
                        </Stack>
                        <CircularProgress size={20} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </Box>

        </Box>
    );
}
